export const filterNodes = (nodes, filters) => {
  const filterKeys = Object.keys(filters);
  if (filterKeys.length === 0) return nodes;

  return nodes.reduce((acc, node) => {
    // 1. Check if this node matches the filters it possesses
    const possessedKeys = filterKeys.filter(k => 
      (node.dimensions && node.dimensions[k] !== undefined) || 
      (node.metrics && node.metrics[k] !== undefined)
    );

    const satisfiesPossessed = possessedKeys.every(k => {
      const val = node.dimensions[k] !== undefined ? node.dimensions[k] : node.metrics[k];
      const selected = filters[k];
      const stringVal = String(val);
      return Array.isArray(selected)
        ? selected.map(String).includes(stringVal)
        : stringVal === String(selected);
    });

    // Prune if it explicitly mismatches a key it has
    if (possessedKeys.length > 0 && !satisfiesPossessed) {
      return acc;
    }

    // 2. Recurse to children
    const filteredChildren = filterNodes(node.children || [], filters);

    // 3. Decision
    const isExplicitMatch = possessedKeys.length > 0 && satisfiesPossessed;
    const hasMatchingChildren = filteredChildren.length > 0;

    // Keep if branch leads to a match or is a match itself
    if (isExplicitMatch || hasMatchingChildren) {
      acc.push({
        ...node,
        children: filteredChildren
      });
    }

    return acc;
  }, []);
};

export const sortNodes = (nodes, sortRules, dimensionsArray = [], metricsArray = []) => {
  if (!nodes || nodes.length === 0) return [];
  if (!sortRules || sortRules.length === 0) return nodes;

  const sorted = [...nodes].sort((a, b) => {
    for (const rule of sortRules) {
      let aVal, bVal;
      // In AnalyticsPage, we might not always have the dimensionsArray/metricsArray fully synced if passed from props
      // but usually we check existence in dimensions/metrics maps
      if (a.dimensions && a.dimensions[rule.key] !== undefined) {
        aVal = a.dimensions[rule.key];
        bVal = b.dimensions[rule.key];
      } else if (a.metrics && a.metrics[rule.key] !== undefined) {
        aVal = a.metrics[rule.key];
        bVal = b.metrics[rule.key];
      }

      // Handle null/undefined
      if (aVal === null || aVal === undefined) aVal = 0;
      if (bVal === null || bVal === undefined) bVal = 0;

      if (aVal < bVal) {
        return rule.direction === 'asc' ? -1 : 1;
      }
      if (aVal > bVal) {
        return rule.direction === 'asc' ? 1 : -1;
      }
    }
    return 0;
  });

  return sorted.map(node => ({
    ...node,
    children: sortNodes(node.children, sortRules, dimensionsArray, metricsArray)
  }));
};
